export const STATUS_SEVERITIES = {
  available: "var(--status-available)",
  busy: "var(--status-busy)",
};
